import { MediaSetContext } from "@perceptron/utils/types";
import FileHandler from "@tiptap/extension-file-handler";

import { Role } from "@demo/types/base";
import { handleFileDrop } from "@demo/utils/file-handler";

export interface FileHandlerOptions {
  context: MediaSetContext;
  role?: Role;
}

/**
 * Drop handling only — file pastes never reach this extension because
 * ClipboardGuard (priority 10000) intercepts them first and routes through
 * handleFilePaste itself.
 *
 * No allowedMimeTypes pre-filter: the stock extension silently discards
 * non-matching files before onDrop fires, which swallowed the unsupported-file
 * toast for mixed drops. validateFiles (inside handleFileDrop) is the single
 * validation + toast point.
 */
export const fileHandlerExtension = (
  { context, role = Role.USER }: FileHandlerOptions = {
    context: MediaSetContext.DOCUMENT_EDITOR,
  },
) => {
  return FileHandler.configure({
    onDrop: (currentEditor, files, pos) => {
      // Disable drag and drop for system prompt
      if (role === Role.SYSTEM) {
        return false;
      }
      handleFileDrop(context, currentEditor, files, pos);
      return true; // Prevent default behavior
    },
  });
};
